
import { defineComponent, ref, reactive } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import PageContent from '@/components/page-content'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/use-page-search'
import { fetchSetTeacher } from '@/service/main/system/depart'

export default defineComponent({
  name: 'department',
  components: {
    PageContent
  },
  setup() {
    const [pageContentRef, handleResetClick, handleQueryClick] = usePageSearch()
    const teachingObj = {
      1: '线下',
      2: '线上'
    }

    const successObj = {
      1: '完成',
      0: '未完成'
    }

    const departRef = ref<InstanceType<typeof PageContent>>()

    // 详情相关
    const detailVisible = ref(false)
    const detailInfo = reactive({
      objId: '',
      name: '',
      phone: '',
      studentAge: '',
      levelName: '',
      gradeName: '',
      duration: '',
      teacherAge: '',
      schoolName: '',
      stuAddress: '',
      teachingWayKey: 1,
      subjectName: '',
      teacherPhone: '',
      isSuccess: 0,
      remark: '',
      teacherName:''
    })

    const showDetail = (row: any) => {
      // 使用Object.keys遍历赋值，避免遗漏字段
      Object.keys(detailInfo).forEach(key => {
        if (key in row) {
          (detailInfo as any)[key] = row[key]
        }
      })
      detailVisible.value = true
    }

    /* 授课完成 */
    const handleConfirm = (id: string) => {
      ElMessageBox.confirm(
        '该教师是否已经授课完成?',
        '授课完成',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          fetchSetTeacher('/pc/publish/editInfo',{
            objId: id,
            isSuccess: 1
          }).then(res=>{
            departRef.value?.getPageData()
            ElMessage({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {
          console.log('err')
        })
    }

    return {
      handleResetClick,
      handleQueryClick,
      contentTableConfig,
      teachingObj,
      successObj,
      handleConfirm,
      departRef,
      detailVisible,
      detailInfo,
      showDetail
    }
  }
})
